module.exports = __webpack_public_path__ + "static/media/294643.18781a3c.png";